<div class="access row px-0 mx-0 justify-content-between">
  <div class="col position-relative px-0">
    <input [id]="input.MainElementList[0].ID" type="text" class="w-100 pr-3 q-input-border q-bo"
           [ngClass]="setClass(input)"          
           [(ngModel)]="input.MainElementList[0].ToolTip"
           [title]="input.MainElementList[0].ToolTip"
           disabled>
    <i *ngIf="!input.MainElementList[0].Disabled" class="fas fa-times q-c-danger q-pointer position-absolute" style="right: 7px; top: calc(50% - 11px);" (click)="OnClear()"></i>
  </div>
  <button *ngIf="input.MainElementList.length > 1"
          class="q-btn q-bo q-main p-0" id="inputGroup-sizing-sm"
          (click)="DownLoadFile(input.MainElementList[1])"
          [title]="input.MainElementList[1].ToolTip"
          ><i class="{{input.MainElementList[1].Src}}"></i></button>

  <button *ngIf="input.MainElementList.length > 2 && input.MainElementList[2].OnClick !== '' && input.MainElementList[2].TypeModal !== 'DOCUWEB'"
          class="q-btn q-bo q-main p-0" id="inputGroup-sizing-sm"
          [title]="input.MainElementList[2].ToolTip"
          (click)="DownLoadFile(input.MainElementList[2])"><i class="{{input.MainElementList[2].Src}}"></i></button>

  <button *ngIf="input.MainElementList.length > 2  && input.MainElementList[2].TypeModal === 'DOCUWEB'" class="q-btn q-bo q-main p-0" id="inputGroup-sizing-sm"
          (click)="OpenGED(ModalGED)"
          [title]="input.MainElementList[2].ToolTip">
    <i class="{{input.MainElementList[2].Src}}"></i>
  </button>

  <button *ngIf="input.MainElementList.length > 3" class="q-btn q-bo q-main p-0" id="inputGroup-sizing-sm"
          [title]="input.MainElementList[3].ToolTip"
          (click)="openUploadDocument(ModalUploadDocument)">
    <i class="{{input.MainElementList[3].Src}}"></i>
  </button>
</div>


<ng-template #ModalGED let-modalGED>
  <div class="modal-header">
    <h5 class="modal-title q-c-main">Gestion Electronique des Documents</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalGED.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0" style="overflow: auto;">
    <div class="container pt-3">
      <q-gestion-electronique-documents (selectChange)="AffectValue($event, modalGED)" singleMode></q-gestion-electronique-documents>
    </div>
  </div>
</ng-template>


<ng-template #ModalUploadDocument let-modalUploadDocument>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLongTitle"></h5>
    <button type="button" class="close" aria-label="Close" (click)="modalUploadDocument.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <q-insertdoc-input class="h-100 w-100" [item]="insertDocModel" (success)="closeModalUpload($event, modalUploadDocument)"></q-insertdoc-input>
  </div>
</ng-template>
